import classNames from 'classnames'
import React, { FC, ReactElement } from 'react'

import { ErrorNotificationOutlet } from '../../../components/ErrorNotification/ErrorNotificationOutlet'
import WixLogo from '../icons/WixLogo.svg'
import s from './WixMobileHeader.scss'

type WixMobileHeaderType = {
  leftContent?: ReactElement
  rightContent?: ReactElement
  hideLogo?: boolean
  skin?: 'new-funnel' | 'standard' | 'harmony'
}

export const WixMobileHeader: FC<WixMobileHeaderType> = ({
  leftContent,
  rightContent,
  hideLogo,
  skin = 'standard',
}) => {
  return (
    <>
      <header
        className={classNames(s.header, {
          [s.headerNF]: skin === 'new-funnel',
          [s.headerHarmony]: skin === 'harmony',
        })}
      >
        <div className={s.column}>{leftContent}</div>
        <div className={s.column}>{!hideLogo && <WixLogo height={skin === 'harmony' ? '16' : '24'} />}</div>
        <div className={s.column}>{rightContent}</div>
      </header>
      <ErrorNotificationOutlet />
    </>
  )
}
